<template>
  <div class="flash">
    <template v-for="goodsInfo in goodsInfoList">
      <div :key="goodsInfo.id" class="main-card" @click="$router.push({path:'/virtual',query:{goodId:goodsInfo.id}})">
        <div class="top">
          <img :src="goodsInfo.cover"/>
        </div>
        <div class="bottom">

          <div class="name">{{ goodsInfo.goodsName }}</div>

          <div class="info">

            <span class="price">￥{{ goodsInfo.price }}</span>
            <span class="spec"> / 张</span>

          </div>

          <!-- <div class="count-down" v-if="!isTimeOver">

          </div> -->

          <div class="btns">

            <!-- <div class="btn grey" v-if="!isTimeOver"> -->

            <!-- <van-count-down :time="countDownTime" format="HH 时 mm 分 ss 秒" @finish="onCountDownFinish" :auto-start="isStart" />
        </div>

        <div class="btn" v-if="isTimeOver&&!isFinish&&!isEmpty&&!isGet " @click="onRushBuy">立即抢购</div>
        <div class="btn" v-if="isTimeOver&&isGet&& !isPayed" @click="onOrderPay">您有一笔订单暂未支付</div>
        <div class="btn grey" v-if="isTimeOver&&isFinish">活动已结束</div>
        <div class="btn grey" v-if="isTimeOver&&isEmpty">已抢光</div> -->
            <div class="btn">立即抢购</div>

          </div>
        </div>

      </div>
      <!-- <div class="main-goods">
          <div class="goods-text" v-html="goodsInfo.content">
          </div>
      </div> -->
    </template>

  </div>
</template>

<script>
import {
  doSecKill,
  getSecOrderInfo,
  getRecordList,
  getStartTime,
  getGoodsInfo,
  getGoodsInfoList
} from "@/api/virtual";
// import { getGoodsInfo } from "@/api/home";
import axios from "axios";
import VConsole from "vconsole";

export default {
  data() {
    return {
      goodsInfoList: [],
      timer: null,
      isTimeOver: false,
      isEmpty: false,
      isPayed: false,
      isFinish: false,
      isGet: false,
      countDownTime: 86399000,
      isStart: false,
      allowToPay: true,
      city: "",
    };
  },

  methods: {
    //获取两个虚拟商品
    async getGoodsInfoList() {
      const {data: res} = await getGoodsInfoList()
      // console.log(test,"@@@@test---------IN GoodsVirtual.VUE------TEST")
      // this.goodsInfoList = [...test.data]
      if (res.code === 200) {
        this.goodsInfoList = [...res.data]

      }
    },
    onCountDownFinish() {
      this.isTimeOver = true;
    },

    onRushBuy() {
      this.doSecKill();
    },

    onOrderPay() {
      this.$router.replace("/order");
    },

    async doSecKill() {
      this.$toast.loading({
        duration: 0,
        message: "抢购中...",
      });

      // if (this.city !== "湖州市" && this.city !== "Huzhou") {
      //     return this.$toast.fail("活动太火爆了");
      // }

      let secKillUrl =
          process.env.NODE_ENV === "development"
              ? // ? "http://192.168.31.50:8081"
              "http://192.168.31.50:8081"
              : process.env.NODE_ENV === "test"
                  ? "https://flash-sale-backend-test.zhijianmedia.cn/rob/"
                  : "https://flash-sale-api.zhijianmedia.cn/rob";

      axios
          .post(secKillUrl + "/secKill/doVirtualSecKill", {
            m2oId: this.$store.state.nthUserInfo.userid,
            token: this.$store.state.token,
            deviceToken: this.$store.state.deviceToken,
          })
          .then((res) => {
            console.log(res.data);

            if (res.data.code == 200) {
              this.$toast.clear();
              this.createTimer();
            } else {
              if (res.data.code == 200100) {
                this.isEmpty = true;
              }

              if (res.data.code == 200102) {
                this.isFinish = true;
              }

              return this.$toast.fail(res.data.msg);
            }
          })
          .catch((err) => {
            this.$toast.clear();

            if (err.request.status == 429) {
              this.$toast.clear();
            }
          });

      // const { data: res } = await axios.post(
      //     secKillUrl + "/secKill/doVirtualSecKill",
      //     {
      //         m2oId: this.$store.state.nthUserInfo.userid,
      //         token: this.$store.state.token,
      //         deviceToken: this.$store.state.deviceToken,
      //     }
      // );

      // console.log("抢购中", res);
      // if (res.code == 200) {
      //     // this.$toast.clear();

      //     this.createTimer();
      // } else {
      //     return this.$toast.fail(res.msg);
      // }
    },

    async getStartTime() {
      const {data: res} = await getStartTime();

      console.log(res, "单个虚拟");
      if (res.code == 200) {
        let date = res.data.replace(/-/g, "/");
        // let date = '2022-04-30 20:00:00'.replace(/-/g, "/");
        this.countDownTime =
            Date.parse(new Date(date)) - new Date().getTime();
        this.isStart = true;
      }
    },

    async getGoodsInfo() {
      const {data: res} = await getGoodsInfo();
      if (res.code == 200) {
        this.$store.commit("setPayLimit", res.data.limit);
      let _res = [{...res.data}]
        console.log(_res,"@@@_Res")
        this.goodsInfoList = [{...res.data}];
        // this.bannerList = res.data.bannerList.split("|");

      }

      console.log(res, "虚拟");
    },

    async getSecOrderInfo() {
      const {data: res} = await getSecOrderInfo({
        m2oId: this.$store.state.nthUserInfo.userid,
      });

      console.log("首次查询订单", res);
      if (res.code == 200) {
        this.isGet = true;
      } else {
        if (res.code == 200100) {
          this.isEmpty = true;
        }

        if (res.code == 200005) {
          this.isPayed = true;
        }

        if (res.code == 200102) {
          this.isFinish = true;
        }
      }
    },

    //轮询订单是否生成
    async getOrder() {
      const {data: res} = await getSecOrderInfo({
        m2oId: this.$store.state.nthUserInfo.userid,
      });

      console.log("轮询订单", res);

      if (res.code == 200) {
        this.$toast.clear();
        // this.$toast.success("抢购成功");
        this.stopTimer();

        if (this.allowToPay) {
          this.allowToPay = false;
          this.$router.push({
            path: "/pay",
            query: {
              data: JSON.stringify(res.data),
            },
          });
        }
      }
      // else{
      //     this.getOrder()
      // }
    },

    createTimer() {
      this.stopTimer();
      this.timer = setInterval(this.getOrder, 1000);
      // this.getOrder()
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    init() {
      const isApp = SmartCity.isSmartCityApp();
      if (isApp) {
        this.getNthUserInfo();
      } else {
        if (process.env.NODE_ENV === "development") {
          return;
        }

        // return this.$toast.fail("请在南太湖号App中打开！");
        this.$router.replace("/share");
      }
    },

    getNthUserInfo() {
      this.$toast.loading({
        duration: 0,
        message: "加载中...",
      });
      SmartCity.getUserInfo((res) => {
        console.log(res);
        if (res && res.userInfo) {
          this.$toast.clear();
          this.$store.commit("setNthUserInfo", res.userInfo);
          this.$store.commit(
              "setUserTokenKey",
              res.userInfo.userTokenKey
          );
          // this.getSecOrderInfo();

          SmartCity.getSystemInfo((res2) => {
            console.log(res2.deviceInfo.device_token, "dev");

            this.$store.commit(
                "setDeviceToken",
                res2.deviceInfo.device_token
            );
          });
        } else {
          this.$toast.clear();
          this.$dialog
              .alert({
                title: "提醒",
                message: "请先登录南太湖号",
              })
              .then(() => {
                this.$router.replace("/error-unlogin");
              });
        }
      });
    },
  },

  created() {
    this.getStartTime();
    this.$skillType === 4 ? this.getGoodsInfoList() : this.getGoodsInfo()
    // this.getGoodsInfoList()
    // this.getGoodsInfo ()

    SmartCity.getLocation((res) => {
      console.log(res);

      if (res.city) {
        // this.city = res.city;
        this.$store.commit(
            "setCity",
            res.city
        );
      }
      // console.log(this.city);
    });

    if (process.env.NODE_ENV === "development") {
      // this.init();

      // return;
      const vConsole = new VConsole();
      // this.init();
      this.$store.commit(
          "setUserTokenKey",
          "b819f6472575f02128c5bd851dbfda74"
      );
      this.$store.commit("setNthUserInfo", {
        userid: "1075",
      });

      this.$store.commit(
          "setDeviceToken",
          "res2.deviceInfo.device_token"
      );
      this.getSecOrderInfo();
    } else if (process.env.NODE_ENV === "test") {
      const vConsole = new VConsole();
      this.init();
    } else {
      this.init();
      // const vConsole = new VConsole();
    }
  },

  activated() {
    console.log("==============");
    // if (this.$store.state.nthUserInfo) {
    //     this.timer = null;
    //     this.isTimeOver = false;
    //     this.isGet = false;
    //     this.isPayed = false;
    //     this.isFinish = false;
    //     this.countDownTime = 0;
    //     this.isStart = false;
    //     this.getStartTime();
    //     this.getGoodsInfo();
    //     if (!this.selectAddressTag) {
    //         this.initOrderData();
    //     }
    // }
  },
};
</script>

<style lang="less" scoped>
.flash {
  width: 100%;
  margin-top: 10px;
  position: relative;
  border-radius: 10px;

  .main-card {
    margin: 15px;
    background: #fff;
    border-radius: 7px;


    .top {
      img {
        width: 100%;
        height: 200px;

        border-radius: 7px 7px 0 0;
      }
    }

    .bottom {
      // flex: 1;
      padding: 15px;

      .name {
        font-size: 16px;
        font-weight: bold;
      }

      .info {
        padding: 10px 0;

        .price {
          color: #f85f3b;
          font-size: 16px;
          font-weight: bold;
          padding: 10px 0;
        }

        .spec {
          font-size: 12px;
          color: #666;
          margin: 4px 0;
          margin-left: 10px;
        }
      }

      .btns {
        display: flex;
        justify-content: center;
        align-items: center;

        .btn {
          width: 99%;
          height: 42px;

          text-align: center;
          padding: 10px 14px;
          border-radius: 20px;
          background: #ff7b07;
          color: #fff;

          display: flex;
          justify-content: center;
          align-items: center;

          .van-count-down {
            color: #fff;
          }
        }

        .grey {
          background: #ccc;
          color: #fff;
        }
      }
    }
  }

  .main-goods {
    padding: 15px;

    .goods-text {
      /deep/ img {
        // border-radius: 10px;
        width: 100%;
        // height: 160px;
        // height: 214px;
        // border-radius: 4px;
      }

      /deep/ video {
        // border-radius: 10px;
        margin-top: 10px;

        width: 100%;
        // height: 160px;
        // height: 214px;
        // border-radius: 4px;
      }

      margin-bottom: 10px;

      /deep/ p {
        color: #666;

        line-height: 28px;

        // text-indent: 2em;
      }

      P {
        margin-block-start: 0;
        margin-block-end: 0;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
      }
    }
  }
}
</style>
